/** Levels selectable with `?level=<key>` (default: lab). */
import type { LevelData } from '../world/LevelData';
import { MOVEMENT_LAB } from './MovementLab';
import { MOVEMENT_PLAYGROUND } from './MovementPlayground';
import { RESEARCH_CHAMBERS } from './ResearchChambers';
import { VIOLET_DESCENT } from './VioletDescent';

export const LEVELS: Readonly<Record<string, LevelData>> = Object.freeze({
  lab: MOVEMENT_LAB,
  chambers: RESEARCH_CHAMBERS,
  track: VIOLET_DESCENT,
  playground: MOVEMENT_PLAYGROUND,
});

export function levelFromQuery(search: string): LevelData {
  const key = new URLSearchParams(search).get('level') ?? 'lab';
  return Object.hasOwn(LEVELS, key) ? LEVELS[key]! : MOVEMENT_LAB;
}
